import React, { useEffect, useState } from 'react';
// import dayjs from 'dayjs';
import {
	Dialog,
	DialogTitle,
	DialogActions,
	DialogContent,
	Typography,
	IconButton,
	Divider,
	Button,
	Box,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { useEditingProfileId } from '../../../../hooks/useEditingProfile';

import { dateFormatter } from '../../../../utils';
import GiaiThuongForm from '../GiaiThuongForm';
import { fileActions, rewardActions } from '../../../../actions';

export default function GiaiThuongUpdate(props) {
	const dispatch = useDispatch();
  const profileId = useEditingProfileId();

	const [values, setValues] = useState(null);
	const [disabled, setDisabled] = useState(true);
	
	const handleSubmit = () => {
		if (values?.previewFile?.[0]) {
			dispatch(fileActions.importPreviewFile(profileId, values?.previewFile[0]))
			.then((response) => {
				dispatch(rewardActions.updateReward({
					...values,
					link: response,
          decisionDay: dateFormatter(values.decisionDay),
				}));
			});
    } else {
			dispatch(rewardActions.updateReward({
				...values,
				decisionDay: dateFormatter(values.decisionDay),
			}));
    }
		props.onClose();
	}

	const handleEdit = () => {setDisabled(false)};

	const handleClose = () => {
		if (disabled) props.onClose();
		else setDisabled(true);
	}

	useEffect(() => {
		setDisabled(true);
		setValues(props.detail);
	}, [props.detail]);

	return (
		<Dialog fullWidth maxWidth='sm' open={!!(props.detail)}>
			<DialogTitle style={{ padding: '4px 12px 4px 24px' }}>
				<Box display='flex' justifyContent='space-between' alignItems='center'>
					<Typography variant='h5'>Chi tiết giải thưởng</Typography>
					<IconButton onClick={props.onClose}><Close /></IconButton>
				</Box>
			</DialogTitle>
			<Divider />
			<DialogContent>
				<GiaiThuongForm
					id='giai-thuong'
					values={values}
					disabled={props.acceptMode ? true : disabled}
					setValues={setValues}
					handleSubmit={handleSubmit}
				/>
			</DialogContent>
			<DialogActions style={{ padding: '8px 24px' }}>
				<Button variant='outlined' onClick={handleClose}>Đóng</Button>
				{/* Màn duyệt thưởng: loại này không có trường số tác giả nên chỉ xem */}
				{!props.acceptMode && (disabled ? (
					<Button variant='outlined' color='secondary' onClick={handleEdit}>Chỉnh sửa</Button>
				) : (
					<Button variant='contained' color='secondary' onClick={handleSubmit}>Xác nhận</Button>
				))}
			</DialogActions>
		</Dialog>
	);
}